<script>
  import Layout from '../layouts/Main.svelte'
</script>

<Layout>
  <div slot="content" class="flex justify-center">
    <div class="max-w-screen-lg">
      <h1 class="text-2xl font-semibold">Imprint & Data Privacy</h1>
      <h2 class="mt-4 text-lg font-semibold">Information in accordance with §5 Telemediengesetz (TMG)</h2>
      <p>
        Operator of the web service at mailwahle.dev is:<br><br>
        Ferdinand Mütsch<br>
        Vorholzstraße 11<br>
        76137 Karlsruhe<br>
        ferdinand(at)muetsch.io
      </p>

      <h2 class="mt-8 text-lg font-semibold">Collected Data</h2>
      <p>
        In order to use this service, it is required to sign up and create a virtual user account. No information, except for an anonymized version of their IP address, is stored for people visiting this website without being registered as a user.<br><br>

        For visitors, who have actively registered as a user, the following information is stored:<br><br>

        – A user name, also known as a pseudonym. It can be chosen arbitrarily by the user.<br>
        – A password. It can be chosen arbitrarily by the user and is only stored as a cryptographic hash. That is, the actual password is not visible to the operator of this web service.<br>
        – A creation date, corresponding to the point in time when the user first signed up.<br>
        – Another date, corresponding to the point in time when the user last logged in into his account to use this web service<br>
        – An anonymized version of the user's IP address for every interaction between the user and this web service.<br><br>

        No other person-related data is stored by this web service. All stored data are only visible to the respective user him- or herself and the operator of this service (mentioned above). No data is shared with third parties at any time. All data is processed and persisted on computers, which are physically located in Germany.
      </p>

      <h2 class="mt-8 text-lg font-semibold">Cookies</h2>
      <p>
        This website does not store cookies of any kind. No "tracking" cookies are set. No social media providers are integrated with this web service.
      </p>

      <h2 class="mt-8 text-lg font-semibold">Information Security</h2>
      <p>
        The operator of this web service takes high efforts to protect users' data. During transport, all data is TLS-encrypted. Passwords are stored only as cryptographic hashes. However, it cannot be guaranteed that no malicious attacker will ever get access to the above mentioned data.
      </p>

      <h2 class="mt-8 text-lg font-semibold">E-Mail Content</h2>
      <p>
        MailWhale as a web service allows registered, as part of its core functionality, to send e-mail, which are relayed through this platform and its according mail servers. However, the operator of this service does not take any kind of respnsibility with respect to the content of e-mail sent by users.
      </p>

      <h2 class="mt-8 text-lg font-semibold">Disclosure & Deletion</h2>
      <p>
        Any person may request information on data privacy at any time, via the above e-mail address. The operator of this service is willing to provide details on what data is stored about any individual on request. Moreover, registered users may contact the operator of this service at any time to request deletion of all their person-related data.
      </p>

      <h2 class="mt-8 text-lg font-semibold">Changes</h2>
      <p>
        We reserve the right to make changes to this policy from time to time. Please review this page periodically to check for updates.
      </p>
    </div>
  </div>

</Layout>
